'use client';
import Script from 'next/script';
import { useEffect } from 'react';
import { ccStorage } from '../../utils/storages/local/CookieStorageClient';

interface MetaTrackingProps {
  pixelId?: string;
  consent?: boolean;
}

const MetaTracking = ({ pixelId, consent }: MetaTrackingProps) => {
  useEffect(() => {
    let ok = consent;
    if (typeof consent === 'undefined') {
      ok = ccStorage.get('cookie-consent');
    }

    if (typeof window.fbq === 'function') {
      if (ok === true) {
        window.fbq('consent', 'grant');
      } else {
        window.fbq('consent', 'revoke');
      }
    }
  }, [consent]);

  return (
    <>
      {pixelId && (
        <>
          <Script id="meta-pixel" strategy="afterInteractive">
            {`
              !function(f,b,e,v,n,t,s)
              {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
              n.callMethod.apply(n,arguments):n.queue.push(arguments)};
              if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
              n.queue=[];t=b.createElement(e);t.async=!0;
              t.src=v;s=b.getElementsByTagName(e)[0];
              s.parentNode.insertBefore(t,s)}(window, document,'script',
              'https://connect.facebook.net/en_US/fbevents.js');
              
              fbq('consent', 'revoke');
              fbq('init', '${pixelId}');
              fbq('track', 'PageView');
            `}
          </Script>
          <noscript>
            <img
              height="1"
              width="1"
              style={{ display: 'none' }}
              src={`https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`}
              alt="Meta Pixel fallback"
            />
          </noscript>
        </>
      )}
    </>
  );
};

export default MetaTracking;
